import { createElement } from 'react';
import { getBexApiContext } from 'bernie-context';
import { toJSON } from 'bernie-core';
import { BexApiProvider } from '@shared-ui/bex-api-context';
import { PlatformContextProvider } from '@bernie/platform-context';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * @param context The baseline context info to populate a Bernie app
 */
function createContextStore(context) {
    var platformContext = __assign({}, context);
    return __assign({ hydrate: function (data) {
            Object.assign(platformContext, data);
        }, toJSON: function () {
            return toJSON(this, ['remoteAddress']);
        }, get localeOptions() {
            return platformContext.site && platformContext.site.supportedLocales
                ? platformContext.site.supportedLocales.filter(function (locale) { return locale.locale !== platformContext.locale; })
                : [];
        },
        set localeOptions(arg) {
            /*noop*/
        },
        get guid() {
            return platformContext.deviceId;
        },
        set guid(arg) {
            /*noop*/
        } }, platformContext);
}

var getExperienceApiProvider = function (options, appData) {
    var experienceApiContext = appData.experienceApiContext;
    if (experienceApiContext && options.enableExperienceApiProvider !== false) {
        return function (_a) {
            var children = _a.children;
            return createElement(BexApiProvider, { context: experienceApiContext }, children);
        };
    }
    return function (_a) {
        var children = _a.children;
        return children;
    };
};

var getPlatformContextProvider = function (options, appData) {
    if (options.enablePlatformContextProvider !== false) {
        return function (_a) {
            var children = _a.children;
            return createElement(PlatformContextProvider, { context: appData.context }, children);
        };
    }
    return function (_a) {
        var children = _a.children;
        return children;
    };
};

function ContextPlugin(pluginOptions) {
    if (pluginOptions === void 0) { pluginOptions = {}; }
    return {
        name: 'context',
        onBrowserHydrateRenderContext: function (pluginContext, next) {
            var hydratedState = pluginContext.hydratedState, setAppData = pluginContext.setAppData;
            var ctx = hydratedState.context;
            var context = createContextStore(ctx);
            var experienceApiContext = getBexApiContext(context);
            setAppData({ context: context, experienceApiContext: experienceApiContext });
            return next(pluginContext);
        },
        onBrowserWrapRootElement: function (pluginContext, next) {
            var getAppData = pluginContext.getAppData, setRootElement = pluginContext.setRootElement;
            var appData = getAppData();
            var PlatformContextProvider = getPlatformContextProvider(pluginOptions, appData);
            var ExperienceApiProvider = getExperienceApiProvider(pluginOptions, appData);
            setRootElement(function (RootElement) { return function (props) { return (createElement(PlatformContextProvider, null,
                createElement(ExperienceApiProvider, null,
                    createElement(RootElement, null, props.children)))); }; });
            return next(pluginContext);
        }
    };
}

export default ContextPlugin;
//# sourceMappingURL=browser.js.map
